import Scope from '../enums/scopes.enum';
import { PatronType } from './patron-type.model';
import { Role } from './role.model';

export interface GrantsModel {
  grantParams?: {
    district_id: string,
    site_guid: string,
    user_guid: string
  },
  patronType: PatronType;
  role: Role;
  permissions: string[];
  scopes: Scope[];
  imsRole: string;
  persona: string;
  portalPermissions?: PortalPermissions;
  destinyChatbotEnabled?: boolean; //LCP-604 value comes from AASP's siteAttr endpoint and added to grants returned from Destiny by portal be.
}

export interface PortalPermissions {
  clmActive?: boolean;
}

export enum GrantsPermissions {
  JUNIPER_SIDECAR_ACCESS_LIBRARY = 'accessAILibraryFunctionality',
  JUNIPER_SIDECAR_ACCESS_RESOURCE = 'accessAIResourceFunctionality',
  DASHBOARD_SHOW_LIBRARY = 'DashboardShowLibrary',
  DASHBOARD_SHOW_RESOURCE = 'DashboardShowAsset',
  DEFAULT_UD_SEARCH = 'DefaultUDSearch',
  VIEW_HOME_PAGE = 'viewHomePage',
  GUEST_EXIT_UD = 'GuestExitUD',
  SHOW_HIDDEN_MATERIALS = 'ShowHiddenMaterials',
  ONE_SEARCH = 'OneSearch',
  BASIC_SEARCH = 'BasicSearch',
  UD_SEARCH = 'UDSearch',
  WEB_PATH_EXPRESS_SEARCH = 'WebPathExpressSearch'
}
